import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, AppTypes } from 'st-app/Services/AppService';
import ParticipantModuleConfig from '../Models/ParticipantsConfig/ParticipantModuleConfig';
import ParticipantModuleConfigLookup from '../Models/ParticipantsConfig/Queries/ParticipantModuleConfigLookup';

export interface IParticipantModuleConfigApiClient {

    /**
     * Gets the Participant module config.
     * @returns The Participant module config.
     */
    get(): AxiosPromise<Model.PlainTrackedObject<ParticipantModuleConfig>>;

    /**
     * Gets the participant module config lookup.
     * @returns An AxiosPromise containing the participant module config lookup object.
     */
    lookup(): AxiosPromise<Model.PlainObject<ParticipantModuleConfigLookup>>;

    /**
     * Updates the Participant module config.
     * @param config The update config.
     * @returns An AxiosPromise representing the asynchronous update operation.
     */
    update(config: Model.PartialPlainObject<ParticipantModuleConfig>): AxiosPromise;

    // Client only properties / methods
}

@injectable()
export default class ParticipantModuleConfigApiClient extends Data.ApiClientBase implements IParticipantModuleConfigApiClient {

    constructor(config = AppService.get(AppTypes.Shared.Config)) {
        super(`${config.ParticipantsApi.ApiPath}/config`);
    }

    public get(): AxiosPromise<Model.PlainTrackedObject<ParticipantModuleConfig>> {
        return this.axios.get(`${this.apiPath}`);
    }

    public lookup(): AxiosPromise<Model.PlainObject<ParticipantModuleConfigLookup>> {
        return this.axios.get(`${this.apiPath}/lookup`);
    }

    public update(config: Model.PartialPlainObject<ParticipantModuleConfig>): AxiosPromise {
        return this.axios.post(`${this.apiPath}`, config);
    }

    // Client only properties / methods
}